
import { CompaniesSearch } from "@/components/companies/CompaniesSearch";
import { useCompaniesFilter } from "@/contexts/CompaniesFilterContext";

export const CompaniesFilterWrapper = () => {
  const {
    searchTerm,
    setSearchTerm,
    currentPage,
    setCurrentPage
  } = useCompaniesFilter();

  // Reset to first page when filters change
  const handleSearchTermChange = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  return (
    <CompaniesSearch 
      searchTerm={searchTerm}
      setSearchTerm={handleSearchTermChange}
    />
  );
};
